module.exports = __webpack_public_path__ + "img/puzzle_30.c030bd31.png";